import React from 'react';
import styles from './Paginator.module.scss';
import Text from '../text/Text';
// import navArrow from './arrow.svg';
import { useTranslation } from 'react-i18next';
import useIsRtl from '../../../app/helpers/isRtl';
import getCookie from '../../../app/helpers/getCookie';
const navArrow = '/assets/svg/Arrows_Left.svg';
const Paginator = ({
  currentPage,
  totalCount,
  itemsPerPage,
  onPageChange,
  pagesToShow = 2,
  hidePages,
  color,
  svgStyle,
  className,
  onItemsPerPageChange,
}) => {
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');
  const isRtl = useIsRtl();
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 2) {
      pages.push(1, 2, 3, '...', totalPages);
    } else if (currentPage >= totalPages - 1) {
      pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage, currentPage + 1, currentPage + 2);
    }

    return pages;
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== currentPage && pageNumber !== '...') {
      onPageChange(pageNumber);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div
      className={`${styles['paginator-container']} 
    ${!isRtl ? styles.rtl : ''} 
    ${getPageNumbers().length > 3 ? styles['many-pages'] : ''}`}
    >
      {/* {hidePages ? null : (
        <div className={`${styles.paging} ${isRtl ? '' : styles['ltr']}`}>
          <Text
            title={isEnglish ? 'Show' : 'common.show'}
            variant="text-bold-italic-16"
            color="#1a1a1a"
            className={styles.perPageText}
          />
          <div className={styles.selectWrapper}>
            <select
              className={styles.select}
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            >
              {[10, 20, 25, 30].map((count) => (
                <option key={count} value={count}>
                  <Text
                    title={count}
                    variant="text-bold-italic-16"
                    color="#1a1a1a"
                  />
                </option>
              ))}
            </select>
          </div>
        </div>
      )} */}

      <div className={`${styles.paginator} ${className ?? ''}`}>
        <div
          className={`${styles['prev-container']} ${
            (!isRtl ? currentPage < totalPages : currentPage > 1)
              ? styles.active
              : styles.disabled
          }`}
          onClick={!isRtl ? handleNext : handlePrev}
        >
          <img
            src={navArrow}
            alt=""
            className={styles.prev}
            style={{
              ...svgStyle,
              transform: !isRtl ? 'rotate(360deg)' : 'rotate(180deg)',
            }}
          />
        </div>
        <div className={`${styles.numbers} ${!isRtl ? styles['rtl-nb'] : ''}`}>
          {getPageNumbers().map((pageNumber, index) => (
            <div
              key={`${pageNumber}-${index}`}
              className={`${styles.text} ${
                currentPage === pageNumber ? styles.active : ''
              }`}
              onClick={() =>
                typeof pageNumber === 'number'
                  ? handlePageChange(pageNumber)
                  : null
              }
              style={{
                cursor: typeof pageNumber === 'number' ? 'pointer' : 'default',
              }}
            >
              <Text
                title={pageNumber.toString()}
                variant="text-bold-20-black"
                color={
                  currentPage === pageNumber && typeof pageNumber === 'number'
                    ? '#008755'
                    : '#1a1a1a'
                }
                style={{ cursor: 'pointer' }}
                className={styles.pageNumber}
              />
            </div>
          ))}
        </div>
        <div
          className={`${styles['next-container']} ${
            (!isRtl ? currentPage > 1 : currentPage < totalPages)
              ? styles.active
              : styles.disabled
          }`}
          onClick={!isRtl ? handlePrev : handleNext}
        >
          <img
            src={navArrow}
            alt=""
            className={styles.next}
            style={{
              ...svgStyle,
              transform: !isRtl ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Paginator;
